import { Component, OnInit } from '@angular/core';
import BaseDetailPageConfig from '../../../../models/base-detail-page.config';
import { CategoriesService } from '../../../../services/api/general-settings/categories.service';
import { BaseDetailPageComponent } from '../../../../components/pages/base-detail-page/base-detail-page.component';
import { RouteService } from '../../../../services/route.service';

@Component({
  selector: 'app-category-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './category-detail-page.component.html',
  styleUrl: './category-detail-page.component.scss'
})
export class CategoryDetailPageComponent implements OnInit {
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail: boolean

  category?: any;

  constructor(
    private categoriesService: CategoriesService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Categories',
      cardTitle: 'Category Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Category',
        onClick: () => {
          this.routeService.categoryUpdate(this.category.categoryId)
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => {
              return item.code;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },
          {
            attribute: 'createTime',
            label: 'Create Time',
            value: (item: any) => {
              return item.createTime;
            }
          },
        ]
      },
      apiDetailService: (categoryId: number) => this.categoriesService.detail(categoryId),
      routeParamName: 'categoryId',
      responseModelName: 'category'
    };

  }

  onLoadedDetail(data: any) {
    this.category = data;
  }
}
